import { DeepResearchService } from "../../libs/ui/src/abstractServices/apiServices";
import { mlClient } from "../apiService";

export const deepResearchService = new DeepResearchService({ client: mlClient });   